export const SET_BREADCRUMBS_LIST = '@@breadcrumbs/SET_BREADCRUMBS_LIST';
